import React from 'react';
import {RelateItemsList} from '@ey/canvascoreservices';
import {labels, currentResource} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import styled from 'styled-components';

export default function RelateItemList(props) {
	const {
		configuration,
		styleName,
		className,
		selectedItems,

		// Headers
		selected,
		showSelectedOnlyCheckBox,
		showSelectedOnlyText,
		componentHeader,
		listHeaders,

		loader,
		title,

		//#region Toolbar
		onResolve,
		onFilter,
		search,

		searchPlaceholder,
		searchClearHoverText,
		searchHoverText,
		onSearch,
		onSearchClear,
		handleDuplicateIds,
		additionalToolbarComponent,
		//#endregion

		//#region Pagination
		pagination,
		optionsPerPage,
		page,
		pageSize,

		onPageSizeChanged,
		onPageChanged,
		//#endregion

		filter,
		searchString,

		noResultsLabel,
		noDataLabel,

		paginationIconHover,
		paginationShowText,
		paginationLabel,
		expandText,
		collapseText,
		showAddedLabel,
		addedLabel,
		labelPlaceholder,
		customLabelTextWidth,
		isModalOpen
	} = props;

	const _expandText = expandText || labels.expand;
	const _collapseText = collapseText || labels.collapse;
	const _className = className || styleName;
	const paginationShowTextLabel = paginationLabel || labels.pagingShowtext;

	return (
		<StyledRelateTaskItemsList className="StyledRelateTaskItemsList">
			<RelateItemsList
				additionalToolbarComponent={additionalToolbarComponent}
				showAddedLabel={showAddedLabel}
				addedLabel={addedLabel}
				title={title}
				configuration={configuration}
				componentHeader={componentHeader}
				listHeaders={listHeaders}
				selected={selected}
				selectedItems={selectedItems}
				showSelectedOnlyCheckBox={showSelectedOnlyCheckBox}
				loader={loader}
				search={search}
				searchPlaceholder={searchPlaceholder}
				searchClearHoverText={searchClearHoverText}
				onResolve={onResolve}
				onFilter={onFilter}
				onSearch={onSearch}
				onSearchClear={onSearchClear}
				handleDuplicateIds={handleDuplicateIds}
				pagination={pagination}
				optionsPerPage={optionsPerPage}
				page={page}
				pageSize={pageSize}
				onPageSizeChanged={onPageSizeChanged}
				onPageChanged={onPageChanged}
				filter={filter}
				searchString={searchString}
				noResultsLabel={noResultsLabel}
				noDataLabel={noDataLabel}
				paginationIconHover={paginationIconHover}
				paginationShowText={paginationShowText}
				paginationButtonLabels={currentResource.pagingSvgHoverText}
				showSelectedOnlyText={showSelectedOnlyText}
				searchHoverText={searchHoverText}
				expandText={_expandText}
				collapseText={_collapseText}
				labelPlaceholder={labelPlaceholder}
				paginationLabel={paginationShowTextLabel}
				className={_className}
				styleName={styleName}
				theme={Utility.getTheme()}
				customLabelTextWidth={customLabelTextWidth}
				isModalOpen = {isModalOpen}
			/>
		</StyledRelateTaskItemsList>
	);
}

const StyledRelateTaskItemsList = styled.section`
	height: 100%;
	width: 100%;
	.relate-item-list-labelTxt {
		width: 85%;
	}
`;
